<template>
  <svg
    :width="size * 1.54"
    :height="size"
    viewBox="0 0 37 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.59573 14.6199V15.9999H12.8877V14.6199H11.2317V8.04394H9.74373L7.54773 8.94394L7.95573 10.1559L9.51573 9.51994V14.6199H7.59573Z"
      :fill="color"
    />
    <path d="M15.6857 15.9999V14.1759H13.9217V15.9999H15.6857Z" :fill="color" />
    <path
      d="M20.0966 16.1559C22.0526 16.1559 23.3606 14.9679 23.3606 11.9079C23.3606 8.97994 22.2806 7.88794 20.2286 7.88794C18.2606 7.88794 16.9526 9.06394 16.9526 12.1239C16.9526 15.0519 18.0446 16.1559 20.0966 16.1559ZM20.1446 14.8239C19.2206 14.8239 18.7286 14.2479 18.7286 12.0399C18.7286 9.85594 19.2566 9.21994 20.1686 9.21994C21.0926 9.21994 21.5966 9.79594 21.5966 11.9919C21.5966 14.1999 21.0566 14.8239 20.1446 14.8239Z"
      :fill="color"
    />
    <path
      d="M29.6423 9.90394H27.9023C27.6983 10.3239 27.5423 10.6719 27.4223 10.9719C27.1943 11.5119 27.0623 11.8839 26.9903 12.0879H26.9663C26.8703 11.7999 26.7263 11.4399 26.4503 10.8879L25.8743 9.80794L24.0743 9.91594L25.6223 12.8919L23.9423 15.9999H25.6943C25.9343 15.5319 26.0663 15.2199 26.2703 14.8119C26.5223 14.2479 26.7143 13.8039 26.7623 13.6239H26.7983C26.8703 13.8639 26.9903 14.1999 27.3743 14.9319L28.0103 16.1079L29.8103 15.9999L28.1423 12.7959L29.6423 9.90394Z"
      :fill="color"
    />
    <mask id="path-2-inside-1" fill="transparent">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      :fill="color"
    />
    <path
      d="M12 2.6H25V0H12V2.6ZM2.6 12C2.6 6.80852 6.80852 2.6 12 2.6V0C5.37258 0 0 5.37258 0 12H2.6ZM12 21.4C6.80852 21.4 2.6 17.1915 2.6 12H0C0 18.6274 5.37258 24 12 24V21.4ZM25 21.4H12V24H25V21.4ZM34.4 12C34.4 17.1915 30.1915 21.4 25 21.4V24C31.6274 24 37 18.6274 37 12H34.4ZM25 2.6C30.1915 2.6 34.4 6.80852 34.4 12H37C37 5.37258 31.6274 0 25 0V2.6ZM1.3 12C1.3 6.09055 6.09055 1.3 12 1.3V-1.3C4.65461 -1.3 -1.3 4.65461 -1.3 12H1.3ZM12 22.7C6.09055 22.7 1.3 17.9094 1.3 12H-1.3C-1.3 19.3454 4.65461 25.3 12 25.3V22.7ZM25 22.7H12V25.3H25V22.7ZM35.7 12C35.7 17.9094 30.9094 22.7 25 22.7V25.3C32.3454 25.3 38.3 19.3454 38.3 12H35.7ZM25 1.3C30.9094 1.3 35.7 6.09055 35.7 12H38.3C38.3 4.65461 32.3454 -1.3 25 -1.3V1.3ZM12 1.3H25V-1.3H12V1.3Z"
      :fill="color"
      mask="url(#path-2-inside-1)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
